import React, { createContext, useState, useContext, ReactNode } from "react";
import { Editor } from "grapesjs";

interface ModalEditorContextType {
  editor: Editor | null;
  setEditor: React.Dispatch<React.SetStateAction<Editor | null>>;
}

const ModalEditorContext = createContext<ModalEditorContextType | undefined>(
  undefined
);

interface ModalEditorProviderProps {
  children: ReactNode;
}

export const ModalEditorProvider: React.FC<ModalEditorProviderProps> = ({
  children,
}) => {
  const [editor, setEditor] = useState<Editor | null>(null);

  return (
    <ModalEditorContext.Provider value={{ editor, setEditor }}>
      {children}
    </ModalEditorContext.Provider>
  );
};

export const useModalEditor = (): ModalEditorContextType => {
  const context = useContext(ModalEditorContext);
  if (!context) {
    throw new Error("useModalEditor must be used within a ModalEditorProvider");
  }
  return context;
};
